import { render, staticRenderFns } from "./Lgx266206729396551680.vue?vue&type=template&id=2c99f4bf&"
import script from "./Lgx266206729396551680.vue?vue&type=script&lang=js&"
export * from "./Lgx266206729396551680.vue?vue&type=script&lang=js&"
import style0 from "./Lgx266206729396551680.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports